import { createLucideIcon } from 'lucide-react';
import { tennisBall } from '@lucide/lab';

const LucideTennisBall = createLucideIcon('TennisBall', tennisBall);

interface TennisBallIconProps {
  color: string;
  size?: number;
  title?: string;
}

export function TennisBallIcon({ color, size = 16, title }: TennisBallIconProps) {
  return (
    <LucideTennisBall
      size={size}
      color={color}
      aria-label={title}
    />
  );
}

export function getBallLevelColor(ballLevel: string | null | undefined) {
  switch (ballLevel) {
    case 'red':
      return { color: '#ef4444', label: 'Red' };
    case 'orange':
      return { color: '#f97316', label: 'Orange' };
    case 'green':
      return { color: '#22c55e', label: 'Green' };
    case 'yellow':
      return { color: '#facc15', label: 'Yellow' };
    default:
      return null;
  }
}
